import { configureApiClient } from '@nohara-dxdev/oidc-core';
import { getAuthToken, refreshAuthToken, clearAuthSession } from '@nohara-dxdev/react-oidc';
import { AxiosError, type AxiosInstance } from 'axios';

import { env } from '@/config/env';
import { getFeatureDisabledHandler } from '@/features/feature-flags/utils';

export const api: AxiosInstance = configureApiClient({
  baseURL: `${env.API_ENDPOINT}/v1`,
  getAuthToken: getAuthToken,
  refreshAuthToken: refreshAuthToken,
  onUnauthorized: clearAuthSession,
});

export const featureDisabledInterceptor = (error: unknown): Promise<never> => {
  if (error instanceof AxiosError && error.response?.status === 403) {
    const body = error.response.data as { code?: string } | undefined;
    if (body?.code === 'FEATURE_DISABLED') {
      getFeatureDisabledHandler()?.();
    }
  }
  return Promise.reject(error as Error);
};

api.interceptors.response.use((response) => response, featureDisabledInterceptor);
